/**
 * 用户相关
 */
import API from "./api";
import request from "./request";

// 获取服务器当前时间
export function getCurrentTimeApi(params = {}) {
  return request({
    url: API.GET_CURRENT_TIME,
    method: "GET",
    params,
  }).catch((e) => e);
}

// 微信code登录
export async function weChatLoginApi(params) {
  return request({
    url: API.weChatLogin,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 判断手机号是否需要验证码
// export async function checkImageCodeV3Api(params) {
//   return request({
//     url: API.checkImageCodeV3,
//     method: "GET",
//     params,
//   }).catch((e) => e);
// }
// 获取图形验证码
// export async function imageCodeApi(params) {
//   return request({
//     url: API.imageCode,
//     method: "GET",
//     params,
//   }).catch((e) => e);
// }
// 发送短信验证码
export async function smsValidCodeApi(data) {
  return request({
    url: API.smsValidCode,
    method: "POST",
    data,
  }).catch((e) => e);
}

// 手机号登录并绑定微信
export async function bindingWeChatApi(data) {
  return request({
    url: API.bindingWeChat,
    method: "POST",
    data,
  }).catch((e) => e);
}
// 浏览器手机号登录
export async function bindingLoginApi(data) {
  return request({
    url: API.bindingLogin,
    method: "POST",
    data,
  }).catch((e) => e);
}
// 退出
export async function loginOutApi(data) {
  return request({
    url: API.loginOut,
    method: "POST",
    data,
  }).catch((e) => e);
}
// 老师信息
export async function teacherInfoApi(params) {
  return request({
    url: API.teacherInfo,
    method: "GET",
    params,
  }).catch((e) => e);
}
export async function infoCompleteApi(data) {
  return request({
    url: API.infoComplete,
    method: "POST",
    data,
  }).catch((e) => e);
}
export async function modifyPersonalSetApi(data) {
  return request({
    url: API.modifyPersonalSet,
    method: "POST",
    data,
  }).catch((e) => e);
}

export async function getCityApi(params) {
  return request({
    url: API.REGISTER_GET_CITY,
    method: "GET",
    params,
  }).catch((e) => e);
}
export async function getCitySchoolApi(params) {
  return request({
    url: API.REGISTER_GET_PC_CITY_SCHOOL,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 教研会首页
export async function homePageDetailApi(params) {
  return request({
    url: API.GET_INDEX,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 首页-研修
export async function exclusiveInfoApi(params) {
  return request({
    url: API.GET_EXCLUSIVE_INFO,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 更多直播
export async function moreGoingApi(params) {
  return request({
    url: API.GET_MORE_GOING,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 课程分类
export async function morePlatformApi(params) {
  return request({
    url: API.GET_MORE_PLATFORM,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 区域筛选列表
export async function filterAreaListApi(params) {
  return request({
    url: API.GET_FILTER_AREA_LIST,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 搜索列表接口
export async function searchListApi(params) {
  return request({
    url: API.GET_SEARCH_LIST,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 搜索页tab接口
export async function searchTabsApi(params) {
  return request({
    url: API.GET_SEARCH_TAB,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 我的学习
export async function studyListApi(params) {
  return request({
    url: API.GET_STUDY_LIST,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 我的证书
export async function certListApi(params) {
  return request({
    url: API.GET_CERT_LIST,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 证书详情
export async function certInfoApi(params) {
  return request({
    url: API.GET_CERT_INFO,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 证书详情
export async function viewCertApi(params) {
  return request({
    url: API.GET_VIEW_CERT,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 本地研修更多
export async function exclusiveMoreApi(params) {
  return request({
    url: API.GET_MORE_EXCLUSIVE,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 公共学科
export async function commonSubjectListApi(params) {
  return request({
    url: API.GET_COMMON_SUBJECT_LIST,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 名师专区
export async function speakerListApi(params) {
  return request({
    url: API.GET_SPEAKER_LIST,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 名师主页
export async function speakerInfoApi(params) {
  return request({
    url: API.GET_SPEAKER_INFO,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 课程详情
export async function packageInfoApi(params) {
  return request({
    url: API.GET_PACHAGE_INFO,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 课包报名
export async function packageSignUpApi(params) {
  return request({
    url: API.GET_PACKAGE_SIGN_UP,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 播放推流
export async function pollingApi(params) {
  return request({
    url: API.POLLING,
    method: "GET",
    params,
  }).catch((e) => e);
}
export async function addPvApi(params) {
  return request({
    url: API.ADDPV,
    method: "GET",
    params,
  }).catch((e) => e);
}
export async function addPvNoLoginApi(params) {
  return request({
    url: API.ADDPVNOLOGIN,
    method: "GET",
    params,
  }).catch((e) => e);
}
export async function addClassHourTwoMinuteApi(params) {
  return request({
    url: API.GET_ADD_CLASS_HOUR_TWO_MINUTE,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 新增或修改公告内容
export async function addOrUpdataNoticeApi(params) {
  return request({
    url: API.AddOrUpdataNotice,
    method: "GET",
    params,
  }).catch((e) => e);
}
export async function createCertApi(params) {
  return request({
    url: API.GET_CREATE_CERT,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 课程详情
export async function packageInfoNoLoginApi(params) {
  return request({
    url: API.NOLOGIN_GET_PACHAGE_INFO,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 播放推流
export async function pollingNoLoginApi(params) {
  return request({
    url: API.NOLOGIN_POLLING,
    method: "GET",
    params,
  }).catch((e) => e);
}
export async function addClassHourTwoMinuteNoLoginApi(params) {
  return request({
    url: API.NOLOGIN_GET_ADD_CLASS_HOUR_TWO_MINUTE,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 获取七牛云token
export async function getQiniuTokenAPI(params) {
  return request({
    url: API.getQiniuToken,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 获取七牛云token
export async function getQiniuTokenNewAPI(params) {
  return request({
    url: API.getQiniuTokenNew,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 用户举报接口
export async function userJubaoAPI(data) {
  return request({
    url: API.userJubao,
    method: "POST",
    data,
  }).catch((e) => e);
}
// 隐私政策详情
export async function getPrivacyInfoAPI(params) {
  return request({
    url: API.getPrivacyInfo,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 学时记录列表
export async function getClassHourListAPI(params) {
  return request({
    url: API.PACKAGE_CLASSHOURLIST,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 课节老师信息
export async function getSpeakerListAPI(params) {
  return request({
    url: API.SPEAKERLIST,
    method: "GET",
    params,
  }).catch((e) => e);
}
// 课程学习进度
export async function getCourseStudyPercentAPI(params) {
  return request({
    url: API.COURSE_STUDY_PERCENT,
    method: "GET",
    params,
  }).catch((e) => e);
}
